import React from 'react';
import Obfuscate from 'react-obfuscate';
import buttonStyles from './buttonlink.module.sass';

const ButtonLink = (props) => {
  const { email, url, text, variant, addClass } = props

  // console.log('buttonlink addClass: '+addClass)

  if (email){
    return (
      <Obfuscate
        className={[buttonStyles.button, addClass, variant].join(' ')}
        email={email}
        linkText={text}
        // obfuscatedHref={email}
        // obfuscate={true}
        tabIndex="0"
        headers={
          { subject: 'Group inquiry from TrufflePigs.com' }
        }
      >
        {text}
      </Obfuscate>
    )
  }

  return (
    <a className={[buttonStyles.button, addClass, variant].join(' ')} href={url} tabIndex="0">{text}</a>
  )
}

export default ButtonLink